import type { ComponentProps } from 'react'
import moment from 'moment'
import { Base } from '@itsrever/design-system'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { setDatesAnalytics } from '@/redux/features/general-data/general-data-slice'

type DateRange = ComponentProps<typeof Base.DatePicker>['selected']

// The range every analytics page shares, kept in the store so it survives navigation.
export function useAnalyticsDateRange() {
  const dispatch = useAppDispatch()
  const { fromDate, toDate } = useAppSelector(
    (store) => store.generalData.datesAnalytics
  )

  const range: DateRange = {
    from: fromDate ? new Date(fromDate) : undefined,
    to: toDate ? new Date(toDate) : undefined
  }

  const setRange = (next: DateRange) => {
    dispatch(
      setDatesAnalytics({
        period: 2,
        fromDate: moment(next?.from).format('YYYY-MM-DD'),
        toDate: moment(next?.to).format('YYYY-MM-DD')
      })
    )
  }

  return { fromDate, toDate, range, setRange }
}
